import React from 'react';
import { NextPage } from 'next';
import initGraphQLClient from '../client/graphql/initGraphQLClient';
import { withError, withGetServerSideError } from '../client/hocs/with-server-side-error/withServerSideError';
import { EDITORIAL_CONTENT_PAGE_QUERY } from '../client/graphql/queries/editorialContentPage';
import EditorialContentPage, { EditorialContentPageProps } from '../client/components/editorial-content-page/EditorialContentPage';
import { EditorialContentPageQueryResponse } from '../domain/graphcms';

export type RealEstateAgentsAntiMoneyLaunderingProps = EditorialContentPageProps;

export const RealEstateAgentsAntiMoneyLaundering: NextPage<RealEstateAgentsAntiMoneyLaunderingProps> = (props) => (
  <EditorialContentPage {...props} />
);

export const getServerSideProps = withGetServerSideError<RealEstateAgentsAntiMoneyLaunderingProps>(async () => {
  const graphQLClient = initGraphQLClient();
  const { data: { editorialContentPage } } = await graphQLClient.query<EditorialContentPageQueryResponse>({
    query: EDITORIAL_CONTENT_PAGE_QUERY,
    variables: {
      contentId: 'cmcstq35xal3007uifj6g0843',
    },
  });

  const {
    seo, title, mainContent, secondaryContent,
  } = editorialContentPage;

  return {
    props: {
      SEO: {
        title: seo.title,
        description: seo.description,
      },
      title: title.markdown,
      mainContent: mainContent.json,
      mainContentReferences: mainContent.references,
      secondaryBlocks: secondaryContent,
    } as RealEstateAgentsAntiMoneyLaunderingProps,
  };
});
export default withError(RealEstateAgentsAntiMoneyLaundering);
